<mat-form-field class="data-source-container">
  <mat-label>Mode</mat-label>

  <mat-select class="data-options" [(value)]="mode" (selectionChange)="onModelChange()">
    @for (option of options; track option) {
      <mat-option [value]="option.index">
        {{ option.title }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
